var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilesearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_127_266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4467 18.2791L16.7883 14.5604C16.4959 14.1751 16.3755 13.7706 16.407 13.4492C15.3054 14.3672 13.9254 14.8017 12.5562 14.6616C11.1869 14.5215 9.9347 13.8177 9.06187 12.6976C8.18904 11.5775 7.76336 10.1281 7.87403 8.65308C7.98469 7.17806 8.62312 5.79191 9.65552 4.78508C10.6879 3.77824 12.0342 3.22886 13.4122 3.25206C14.7902 3.27526 16.0931 3.86924 17.0477 4.90952C18.0024 5.94981 18.5348 7.35567 18.5333 8.83253C18.5319 10.3094 17.9967 11.7426 17.04 12.8319C17.341 12.8281 17.7044 12.9966 18.0335 13.346L21.2259 16.5439C21.7406 17.0904 21.7383 17.9503 21.2203 18.4555C20.7023 18.9607 19.904 18.8806 19.4477 18.2781L19.4467 18.2791ZM16.7468 9.10504C16.8038 8.09467 16.4843 7.11142 15.8585 6.37159C15.2326 5.63176 14.3518 5.19595 13.4096 5.16005C12.4675 5.12414 11.5413 5.49107 10.8347 6.18012C10.1282 6.86917 9.69919 7.82389 9.64212 8.83426C9.58504 9.84463 9.90456 10.8279 10.5304 11.5677C11.1562 12.3075 12.0371 12.7434 12.9792 12.7793C13.9214 12.8152 14.8476 12.4482 15.5541 11.7592C16.2607 11.0701 16.6897 10.1154 16.7468 9.10504Z",
    fill: "#3B4F7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_127_266",
    x: 0.856812,
    y: 0.251343,
    width: 27.7536,
    height: 29.5364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_127_266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_127_266",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilesearch);
export default __webpack_public_path__ + "static/media/mobilesearch.f0587251c08ecd60d99dbb36d3074036.svg";
export { ForwardRef as ReactComponent };